module.exports = __webpack_public_path__ + "img/7.0_News_4_Radius-article.d5fde4db7da1d49af562e8583022c12e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/7.0_News_4_Radius-article.png
// module id = 799
// module chunks = 0